<!-- eslint-disable -->
<template lang="pug">
    header.datepicker-header
        span.datepicker-header__arrow(@click="previousTime")
            svg-icon(name="angle-left" :inline="true")
        .datepicker-header__text-container
            span.datepicker-header__text(
                :class="[clickable && 'datepicker-header__text--clickable']"
                @click="showCalendar"
            )
                | {{ headerText }}
        span.datepicker-header__arrow(@click="nextTime")
            svg-icon(name="angle-right" :inline="true")
</template>

<script>
    /*eslint-disable*/
    import SvgIcon from "../SvgIcon.vue"

    export default {
        name: "DatepickerHeader",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * Function shows previous time period
             */
            previousTime: Function,
            /**
             * Function shows next time period
             */
            nextTime: Function,
            /**
             * Function shows calendar
             */
            showCalendar: Function,
            /**
             * Header text
             */
            headerText: String,
            /**
             * Whether header clickable
             */
            clickable: Boolean,
        },
        components: {
            SvgIcon,
        },
    }
</script>

<style lang="scss" scoped>
    .datepicker-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        @include stack-space($space-small);

        &__text-container {
            flex-grow: 1;
            text-align: center;
        }

        &__text {
            @include text($font-size-12, $font-weight-bold);
            &.datepicker-header__text--clickable {
                cursor: pointer;
            }
        }

        &__arrow {
            display: flex;
            flex-grow: 0;
            @include reset;
            cursor: pointer;
            @include text($font-size-20);
            color: $color-grey-700;

            &:hover {
              color: $color-shark;
            }
        }
    }
</style>
